export default "__VITE_ASSET__BCiJd9$$__"